<template>
  <div class="product-regcnt">
    <header class="inner-header">
      <img src="../assets/images/backIcon.svg" alt="" @click="$router.go(-1)" />
      <h2>
        {{ $t("Enter Ad Details") }}
      </h2>
      <button class="checkTC" @click="$router.push('/terms-and-conditions')">
        {{ $t("CheckTnC") }}
      </button>
    </header>
    <h3 v-if="$route.query.AdsType === 'WebSite'" class="adstype-heading">
      अपनी मौजूदा वेबसाइट पर ग्राहक जोड़ें
    </h3>
    <h3 v-if="$route.query.AdsType === 'WhatsappLink'" class="adstype-heading">
      व्हाट्सऐप ग्रुप पर ग्राहक जोड़ें
    </h3>
    <h3 v-if="$route.query.AdsType === 'WhatsApp'" class="adstype-heading">
      व्हाट्सऐप पर ग्राहक पाएं
    </h3>
    <h3
      v-if="$route.query.AdsType === 'Product' && adsType == 'Products'"
      class="adstype-heading"
    >
      एक प्रोडक्ट्/सर्विस पर ग्राहक पाएं
    </h3>
    <h3
      v-if="$route.query.AdsType === 'Shop' && adsType === 'Shops'"
      class="adstype-heading"
    >
      एक साथ कई प्रोडक्ट्स पर ग्राहक पाएं
    </h3>
    <section class="mid-cnt">
      <form @submit.prevent="createAd" class="fomr-box">
        <!-- <div class="field-row" v-if="$route.query.AdsType=='Shop' || $route.query.AdsType=='Product' || (detail && detail.shopId)">
          <label class="text-label">
            {{ $t('CreateAds') }}
          </label>
          <div class="adsType">
            <label for="shops" class="adsTypeOptions">
              <input type="radio" id="shops" name="adsType" value="Shops" v-model="adsType"> <span>{{ $t('Shop') }}</span>
            </label>
            <label for="products" class="adsTypeOptions">
              <input type="radio" id="products" name="adsType" value="Products" v-model="adsType"> <span>{{ $t('Product') }}</span>
            </label>
          </div>
        </div> -->
        <div
          class="field-row"
          v-if="
            $route.query.AdsType == 'WhatsApp' ||
            (detail &&
              detail.campaignAction &&
              detail.campaignAction.action === 'WHATS_APP_OPEN')
          "
        >
          <label class="text-label">Enter Your WhatsApp Number</label>
          <input
            type="text"
            name="whatsapp"
            value=""
            class="input-style"
            placeholder="Enter WhatsApp Number"
            v-model="whatsappNumber"
            @blur="$v.whatsappNumber.$touch()"
          />
          <span class="error-msg" v-if="$v.whatsappNumber.$error"
            >WhatsApp Number Cannot be Blank</span
          >
        </div>
        <div
          class="field-row"
          v-if="
            $route.query.AdsType == 'WhatsappLink' ||
            (detail &&
              detail.campaignAction &&
              detail.campaignAction.action === 'WHATS_APP_GROUP_OPEN')
          "
        >
          <label class="text-label">WhatsApp Group Link</label>
          <div class="flx">
            <input
              type="text"
              name="whatsapp"
              value=""
              class="input-style"
              placeholder="Enter Link"
              v-model="whatsappLink"
              @blur="$v.whatsappLink.$touch()"
              style="border-top-right-radius: 0; border-bottom-right-radius: 0"
            />

            <button
              type="button"
              class="no-length-create"
              style="
                border-top-right-radius: 4px;
                border-bottom-right-radius: 4px;
              "
              @click="howToGetLink = !howToGetLink"
            >
              कैसे पाए लिंक
            </button>
          </div>
          <span class="error-msg" v-if="$v.whatsappLink.$error"
            >WhatsApp Link cannot be blank</span
          >
        </div>
        <div class="field-row" v-if="$route.query.AdsType == 'WebSite'">
          <label class="text-label">Website URL</label>
          <input
            type="text"
            name="whatsapp"
            value=""
            class="input-style"
            placeholder="Enter Your Website Link"
            v-model="websiteUrl"
            @blur="$v.websiteUrl.$touch()"
          />
          <span class="error-msg" v-if="$v.websiteUrl.$error"
            >Wbsite Cannot be Blank</span
          >
        </div>

        <div
          class="field-row"
          v-if="
            $route.query.AdsType == 'Shop' ||
            $route.query.AdsType == 'Product' ||
            (detail && detail.shopId)
          "
        >
          <label class="text-label">{{ $t("SelectShop") }}</label>
          <div class="flx">
            <div class="pos-relate">
              <select
                @change="getProductsOfShop(selectedShopId)"
                class="select-opt"
                v-model="selectedShopId"
                @blur="$v.selectedShopId.$touch()"
                style="
                  border-top-right-radius: 0;
                  border-bottom-right-radius: 0;
                "
              >
                <option value="" disabled>{{ $t("SelectShop") }}</option>
                <option
                  v-for="(item, index) in shopsListing"
                  :value="item.shop_id"
                  :key="index"
                >
                  {{ item.name }}
                </option>
              </select>

              <span class="drop-icon">
                <img src="../assets/images/dropIcon.svg" alt="" />
              </span>
            </div>
            <button
              type="button"
              class="no-length-create"
              @click="createShop($event)"
              v-if="!shopsListing.length"
            >
              Create Shop
            </button>
          </div>
          <span class="error-msg" v-if="$v.selectedShopId.$error">{{
            $t("ShopRequired")
          }}</span>
        </div>

        <div
          class="field-row"
          v-if="
            adsType === 'Products' &&
            ($route.query.AdsType == 'Product' || (detail && detail.shopId))
          "
          @click="
            selectedShopId !== ''
              ? (showProductListing = true)
              : (showProductListing = false)
          "
        >
          <div
            v-if="!selectedProduct.hasOwnProperty('itemDTOList')"
            class="pos-relate custom-tab"
          >
            {{ $t("SelectProduct") }}
            <span class="drop-icon">
              <img src="../assets/images/dropIcon.svg" alt="" />
            </span>
          </div>
          <span
            class="error-msg"
            v-if="!selectedProduct.hasOwnProperty('itemDTOList')"
            >{{ formError.product }}</span
          >
        </div>
        <div
          class="field-row"
          v-if="
            adsType == 'Products' &&
            selectedProduct.hasOwnProperty('itemDTOList')
          "
        >
          <label class="text-label">{{ $t("SelectedProduct") }}</label>
          <div class="selected-prdtitem">
            <span class="prdt-icon">
              <img
                :src="
                  selectedProduct.itemDTOList[0].itemMediaDTOList.length
                    ? selectedProduct.itemDTOList[0].itemMediaDTOList[0]
                        .thumbnail
                    : null
                "
                alt=""
              />
            </span>

            <div class="prdt-info">
              <p>{{ selectedProduct.itemDTOList[0].itemName }}</p>
              <div class="price-block">
                <span class="update-price"
                  >₹{{ selectedProduct.itemDTOList[0].mrp }}</span
                >
              </div>
            </div>

            <span class="edit-product" @click="showProductListing = true">
              <img src="../assets/images/editIcon.svg" alt="" />
            </span>
          </div>
        </div>
        <div class="field-row">
          <label class="text-label">{{ $t("Title") }}</label>
          <input
            type="text"
            name="title"
            value=""
            class="input-style"
            :placeholder="$t('EnterTitle')"
            v-model="title"
            @blur="$v.title.$touch()"
          />
          <span class="error-msg" v-if="$v.title.$error">{{
            $t("TitleRequired")
          }}</span>
          <div class="note-msg">
            {{ $t("50 character left") }}
          </div>
        </div>

        <div class="grid-block">
          <div class="grid-col">
            <div class="field-row">
              <div class="date">
                <label class="text-label" for="">
                  {{ $t("Start Date") }}
                </label>
                <datetime
                  type="date"
                  v-model="startDate"
                  :min-datetime="new Date().toISOString()"
                  @blur="$v.startDate.$touch()"
                  auto
                >
                </datetime>
              </div>
              <span class="error-msg" v-if="$v.startDate.$error">{{
                $t("StartDateRequired")
              }}</span>
            </div>
          </div>
          <div class="grid-col">
            <div class="field-row">
              <div class="date">
                <label class="text-label" for=""> {{ $t("End Date") }} </label>
                <datetime
                  type="date"
                  v-model="endDate"
                  :min-datetime="startDate"
                  @blur="$v.endDate.$touch()"
                  auto
                >
                </datetime>
              </div>
              <span class="error-msg" v-if="$v.endDate.$error">{{
                $t("EndDateRequired")
              }}</span>
            </div>
          </div>
        </div>
        <!-- <div class="field-row" v-if="['WebSite','WhatsappLink','WhatsApp'].includes($route.query.AdsType)"> -->
        <div class="field-row">
          <div class="flx">
            <label class="text-label">Choose Ad Target</label>
            <p v-if="totalUserCount" class="add-count">
              Your Ad Reach - {{ totalUserCount }} Customers
            </p>
          </div>
          <div class="flx">
            <div class="pos-relate">
              <select
                @change="getSelectedPincodeOption(selectedPincodeOption)"
                class="select-opt"
                v-model="selectedPincodeOption"
              >
                <option value="ALL_INDIA">All India</option>
                <option value="ADD_PINCODE">Add Pincode</option>
              </select>

              <span class="drop-icon">
                <img src="../assets/images/dropIcon.svg" alt="" />
              </span>
            </div>
          </div>

          <div v-if="selectedPincodeOption === 'ADD_PINCODE'">
            <ul v-if="supportedPincodeList.length" class="chiplisting">
              <li v-for="(pincode, index) in supportedPincodeList" :key="index">
                <span class="text-label">{{ pincode }}</span>
                <span class="remove-pin" @click="removePincode(index)">
                  <close-icon />
                </span>
              </li>
            </ul>
            <input
              name="supportedPincodeList"
              type="number"
              id="text_val"
              placeholder="ऐड कहाँ दिखाना चाहते हैं "
              @input="getSupportedPin"
              class="input-style"
              style="width: 50%; margin-top: 8px"
            />
          </div>
        </div>
        <div class="field-row">
          <label class="text-label">{{ $t("Description") }}</label>
          <textarea
            class="textare-style"
            :placeholder="$t('EnterDescription')"
            name="description"
            v-model="description"
            @blur="$v.description.$touch()"
          ></textarea>
          <!-- v-model="description" -->
          <span class="error-msg" v-if="$v.description.$error">{{
            $t("DescriptionRequired")
          }}</span>
          <div class="note-msg">
            {{ $t("250 character left") }}
          </div>
        </div>
        <div class="field-row" v-if="adsType === 'Shops'">
          <label class="text-label">{{ $t("Product Image") }}</label>
          <span class="img-preview" v-if="cropped"><img :src="cropped" /></span>
          <vue-croppie
            v-if="fileValue"
            ref="croppieRef"
            :enableOrientation="true"
            :boundary="{ width: '100%', height: '200' }"
            :viewport="{ width: '100%', height: 146, type: 'square' }"
          >
          </vue-croppie>
          <div v-if="fileValue" class="crop-btnbox">
            <button class="button" @click.prevent="crop">Crop Image</button>
          </div>
          <div class="input-placebox">
            <input class="inputfile" type="file" @change="croppie" />
            {{ $t("Upload Image") }}
            <span class="icon-Btn">
              <img src="../assets/images/upload-icon.svg" alt="" />
            </span>
          </div>
        </div>
      </form>

      <div class="ftr-form">
        <button :class="disable ? 'btn disable' : 'btn'" @click="createAd">
          {{ $route.query.AdId ? $t("Update Ad") : $t("Create Ad") }}
        </button>
      </div>
    </section>
    <loadingIcon v-if="loading" />
    <Toaster :dataValue="toasterData" />
    <ProductListModal
      @input="setProductId"
      :shop-id="selectedShopId.toString()"
      :selected-product-id="
        selectedProduct.hasOwnProperty('itemDTOList')
          ? selectedProduct.itemDTOList[0].sellerItemRelationshipId
          : ''
      "
      @close="showProductListing = false"
      v-if="showProductListing"
    />
    <how-to-get-link
      v-if="howToGetLink"
      @closeGetLinkOption="howToGetLink = !howToGetLink"
    />
    <img
      src="../assets/images/waitingIcon.gif"
      v-if="waitingIcon"
      class="total-image"
    />
  </div>
</template>
<script>
import Vue from "vue";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
Vue.use(Datetime);
import VueCroppie from "vue-croppie";
import "croppie/croppie.css"; // import the croppie css manually
Vue.use(VueCroppie);
import { required } from "../utils/validators";
import { b64toBlob } from "../utils/helper";
import loadingIcon from "../components/Icons/loadingIcon";
import Toaster from "../components/Toaster";
import axios from "axios";
// import Vue from 'vue';
import { mapActions } from "vuex";
// import PaginatedSelection from '@/components/PaginatedSelection';
import ProductListModal from "@/components/ProductListModal";
import ApiRequest from "../services/ApiRequest";
import constant from "../utils/constant";
import { SessionHelper } from "../services/Session";
import HowToGetLink from "./HowToGetLink.vue";
import CloseIcon from "../components/Icons/CloseIcon.vue";
export default {
  name: "CreateAdForm",
  components: {
    // PaginatedSelection,
    loadingIcon,
    Datetime,
    Toaster,
    ProductListModal,
    HowToGetLink,
    CloseIcon,
  },
  async mounted() {
    // this.pincodesList = this.$store.state.pincodesList;
    await this.EditFormPreFilledValue();
    await this.getLocalMallShops();
    // setTimeout(() => {}, 5000);
    // const response = await this.getLocalMallProductsOfShop({
    //   page: 0,
    //   id: this.selectedShopId,
    // });
    // console.log(response);
    if (this.$route.query.AdsType == "Product") {
      this.adsType = "Products";
    } else if (this.$route.query.AdsType == "Shop") {
      this.adsType = "Shops";
    }
  },
  data() {
    return {
      webUrl: "",
      mediaType: 1,
      actionApplicationId: null,
      startDate: "",
      endDate: "",
      disabledDates: {},
      title: "",
      description: "",
      sellingPrice: "",
      imagePreview: null,
      imagePreviewBase64: null,
      mobileNumber: "",
      action: null,
      whatsappNumber: null,
      whatsappLink: null,
      websiteUrl: null,
      supportedPincodeList: [],
      supportedPincode: "",
      selectedPincodeOption: "",
      formError: {
        title: null,
        description: null,
        webUrl: null,
        mobileNumber: null,
        shop: null,
        product: null,
        imagePreview: null,
        whatsappNumber: null,
        whatsappLink: null,
        websiteUrl: null,
      },
      disable: false,
      toasterData: {},
      isNameRequired: false,
      isEmailRequired: false,
      isPhoneNumberRequired: false,
      isPincodeRequired: false,
      loading: false,
      croppieImage: "",
      cropped: null,
      fileValue: null,
      pincodesList: [],
      adsType: "Shops",
      shopsListing: [],
      selectedShopId: "",
      selectedProductId: "",
      productDTOs: [],
      userData: null,
      showProductListing: false,
      selectedProduct: {},
      howToGetLink: false,
      detail: {},
      totalUserCount: null,
      waitingIcon: false,
    };
  },
  validations: {
    title: {
      required,
    },
    selectedShopId: {
      // required
    },
    startDate: {
      required,
    },
    endDate: {
      required,
    },
    description: {
      required,
    },
    whatsappNumber: {
      // required
    },
    whatsappLink: {
      // required
    },
    websiteUrl: {},
    selectedPincodeOption: {},
  },
  methods: {
    ...mapActions({
      getLocalMallShopsList: "getLocalMallShopsList",
      getLocalMallProductsOfShop: "getLocalMallProductsOfShop",
    }),
    getSupportedPin(_event) {
      if (_event.target.value.length == 6) {
        if (this.supportedPincodeList.includes(_event.target.value)) {
          _event.target.value = "";
          this.toasterData = {
            status: true,
            msg: "Pincode already in used",
            timeoutMs: "5000",
            color: "#ff6600",
          };
          return;
        }
        this.supportedPincodeList.push(_event.target.value.trim());
        if (this.selectedPincodeOption === "ADD_PINCODE") {
          this.waitingIcon = true;
          ApiRequest(
            "https://be.payboard.in/PayBoard",
            `/rest/user/get-user-count-for-pincodes/${_event.target.value}`,
            "get"
          )
            .then((response) => {
              this.waitingIcon = false;
              console.log(response.data.userCount);
              this.totalUserCount = Math.round(
                this.totalUserCount + response.data.userCount
              );
            })
            .catch((err) => {
              this.waitingIcon = false;
            });
        }
        _event.target.value = "";
      }
    },
    removePincode(_index) {
      if (this.supportedPincodeList.length === 1) {
        this.totalUserCount = "";
      }
      this.supportedPincodeList.splice(_index, 1);
    },
    createShop(event) {
      event.stopPropagation();
      this.$router.push("/create-shop");
    },
    setProductId(value) {
      this.selectedProduct = value;
      this.selectedProductId = value.itemDTOList[0].sellerItemRelationshipId;
      this.showProductListing = false;
    },
    getSelectedPincodeOption(_option) {
      console.log(_option);
      this.waitingIcon = true;
      if (_option === "ALL_INDIA") {
        this.totalUserCount = "12 Lakh+";
        this.waitingIcon = false;
      } else {
        this.totalUserCount = "";
        this.waitingIcon = false;
      }
    },
    getProductsOfShop(id) {
      const shop = this.shopsListing.find((shop) => shop.shop_id === id);
      // if (shop) this.pincodesList = [shop.address.zip_code];
      if (this.adsType === "Shops") return;
      if (this.selectedShopId !== "") this.selectedProduct = {};
    },
    getLocalMallShops() {
      //   const vm = this;
      // this.getLocalMallShopsList().then((response) => {
      //   this.shopsListing = response;
      // });
      ApiRequest(
        constant.LOCAL_MALL_BASE_API,
        `/shopService/get-seller-shop-list`,
        "get"
      ).then((response) => {
        this.shopsListing = response;
      });
    },

    createAd() {
      if (this.$v.$invalid) {
        console.log("invalid");
        this.$v.$touch();
      } else {
        console.log("valid");
        this.disable = true;
        this.createPayload();
      }
    },

    createPayload() {
      let startDate = new Date(this.startDate).getTime();
      let endDate = new Date(this.endDate).getTime();
      let obj = {
        name: this.title,
        description: this.description,
        startDate,
        endDate,
        pincodes: this.pincodesList,
        mediaType: this.mediaType,
      };
      if (
        this.$route.query.AdsType == "Shop" ||
        this.$route.query.AdsType == "Product"
      ) {
        if (this.selectedShopId) {
          obj.shopId = this.selectedShopId;
        } else {
          this.toasterData = {
            status: true,
            msg: "Please Select Shop",
            timeoutMs: "5000",
            color: "#000",
          };
          this.disable = false;
          return;
        }
      }
      if (this.adsType === "Products") {
        obj.mediaType = 3;
        obj.shopSellerItemRelationshipId = this.selectedProductId;
      }
      if (this.adsType === "Shops") {
        if (this.imagePreview) {
          obj.campaignMedia = [
            {
              mediaURL: this.imagePreview,
            },
          ];
        } else {
          this.toasterData = {
            status: true,
            msg: "Choose Ad Image",
            timeoutMs: "5000",
            color: "#000",
          };
          this.disable = false;
          return;
        }
      }
      if (this.$route.query.AdsType == "WhatsApp") {
        if (
          this.whatsappNumber &&
          new RegExp(/^[0][6-9]\d{9}$|^[6-9]\d{9}$/g).test(this.whatsappNumber)
        ) {
          obj.campaignAction = {
            action: "WHATS_APP_OPEN",
            whatsAppNumber: this.whatsappNumber,
          };
        } else {
          this.toasterData = {
            status: true,
            msg: "Enter valid WhatsApp Number",
            timeoutMs: "5000",
            color: "#000",
          };
          this.disable = false;
          return;
        }
      }
      if (this.$route.query.AdsType == "WhatsappLink") {
        if (
          this.whatsappLink &&
          this.whatsappLink.includes("https://chat.whatsapp.com/")
        ) {
          obj.campaignAction = {
            action: "WHATS_APP_GROUP_OPEN",
            actionURL: this.whatsappLink,
          };
        } else {
          this.toasterData = {
            status: true,
            msg: "Enter valid WhatsAppLink",
            timeoutMs: "5000",
            color: "#000",
          };
          this.disable = false;
          return;
        }
      }
      if (this.$route.query.AdsType == "WebSite") {
        if (
          this.websiteUrl &&
          new RegExp(
            /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi
          ).test(this.websiteUrl)
        ) {
          obj.campaignAction = {
            action: "LINK_OPEN",
            actionURL: this.websiteUrl,
          };
        } else {
          this.toasterData = {
            status: true,
            msg: "Enter valid Website Link",
            timeoutMs: "5000",
            color: "#000",
          };
          this.disable = false;
          return;
        }
      }
      // if(['WebSite','WhatsappLink','WhatsApp'].includes(this.$route.query.AdsType)){
      if (this.selectedPincodeOption) {
        if (this.selectedPincodeOption === "ALL_INDIA") {
          this.pincodesList = [];
        } else if (this.selectedPincodeOption === "ADD_PINCODE") {
          if (this.supportedPincodeList.length) {
            obj.pincodes = this.supportedPincodeList;
          } else {
            this.toasterData = {
              status: true,
              msg: "ऐड कहाँ दिखाना चाहते हैं ?",
              timeoutMs: "5000",
              color: "#000",
            };
            this.disable = false;
            return;
          }
        }
      } else {
        this.toasterData = {
          status: true,
          msg: "Choose Ad Target",
          timeoutMs: "5000",
          color: "#000",
        };
        this.disable = false;
        return;
      }
      // }
      console.log("yahan");
      const { AdId } = this.$route.query;
      if (AdId) {
        ApiRequest(
          constant.ADS_BASE_API_URL,
          `/campaign/details/${AdId}`,
          "get"
        ).then((data) => {
          console.log("data");
          this.detail = data.data;
          obj["campaignIdentifier"] = this.detail.campaignIdentifier;
          obj.campaignAction = this.detail.campaignAction;
          obj.productMedia = this.detail.productMedia;
          const shop = this.shopsListing.find(
            (shop) => shop.shop_id === this.selectedProductId
          );
          // if (shop) this.pincodesList = [shop.address.zip_code];
          if (
            this.adsType === "Products" &&
            !this.selectedProduct.itemDTOList
          ) {
            this.formError.product = this.$t("ProductRequired");
            this.disable = false;
          } else if (this.startDate == this.endDate) {
            this.toasterData = {
              status: true,
              msg: this.$t("StartDateEndDateCannotEqual"),
              timeoutMs: "5000",
              color: "#ff6600",
            };
          } else {
            this.updateAd(obj);
          }
        });
      } else {
        const shop = this.shopsListing.find(
          (shop) => shop.shop_id === this.selectedProductId
        );
        // if (shop) this.pincodesList = [shop.address.zip_code];

        console.log("===else dispatch normal-", obj);
        if (this.adsType === "Products" && !this.selectedProduct.itemDTOList) {
          this.formError.product = this.$t("ProductRequired");
          this.disable = false;
        } else if (this.startDate == this.endDate) {
          this.toasterData = {
            status: true,
            msg: this.$t("StartDateEndDateCannotEqual"),
            timeoutMs: "5000",
            color: "#ff6600",
          };
          this.disable = false;
        } else {
          console.log(obj);
          this.dispatchCreateAds(obj);
        }
      }
    },

    dispatchCreateAds(payload) {
      ApiRequest(
        constant.ADS_BASE_API_URL,
        `/campaign/add-ads`,
        "post",
        payload
      )
        .then((data) => {
          console.log("-data-dispatch-", data);
          if (data.httpStatus) {
            this.disable = false;
            this.loading = false;
            if (data.httpStatus === 200) {
              this.$cookie.set("orderStatus", "my_ads");
              this.$router.replace("/manage-shops?showLocalShop=true");
              this.$store.commit("PincodeList", []);
            }
            this.toasterData = {
              status: true,
              msg: data.message,
              timeoutMs: "5000",
              color: "#ff6600",
            };
            if (data.message === "Invalid Token") {
              console.log("=token error==");
              SessionHelper.refereshJwtToken();
              if (SessionHelper.getCookie("JWT-TOKEN") !== "null") {
                this.dispatchCreateAds();
              }
            }
          }
        })
        .catch(() => {
          this.disable = false;
        });
    },

    updateAd(payload) {
      ApiRequest(
        constant.ADS_BASE_API_URL,
        `/campaign/update-ads`,
        "put",
        payload
      )
        .then((data) => {
          if (data.httpStatus) {
            this.disable = false;
            this.loading = false;
            if (data.httpStatus === 200) {
              this.$cookie.set("orderStatus", "my_ads");
              this.$router.replace("/manage-shops?showLocalShop=true");
            }
            this.toasterData = {
              status: true,
              msg: data.message,
              timeoutMs: "5000",
              color: "#ff6600",
            };
            if (data.message === "Invalid Token") {
              console.log("=token error==");
              SessionHelper.refereshJwtToken();
              if (SessionHelper.getCookie("JWT-TOKEN") !== "null") {
                this.updateAd();
              }
            }
          }
        })
        .catch((err) => {
          this.disable = false;
          console.log("", err.response);
        });
    },
    async uploadImage(file) {
      let formData = new FormData();
      formData.append("image", file, file.type);
      formData.append("isResizeRequired", true);
      axios
        .post(constant.ADS_FILE_UPLOAD_URL, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((data) => {
          this.imagePreview = data.data.mediaVariantDTOs[0].url;
          this.formError.imagePreview = null;
        })
        .catch(() => {
          // toaster(this, this.$t("wentWrongMsg"), "top-left", 2000);
        });
    },
    croppie(e) {
      this.fileValue = e.target.files;
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      var reader = new FileReader();
      reader.onload = (e) => {
        this.$refs.croppieRef.bind({
          url: e.target.result,
        });
      };

      reader.readAsDataURL(files[0]);
    },
    crop() {
      // Options can be updated.
      // Current option will return a base64 version of the uploaded image with a size of 600px X 450px.
      let options = {
        type: "base64",
        size: { width: 340, height: 150 },
        format: "jpeg",
      };
      this.$refs.croppieRef.result(options, (output) => {
        this.cropped = this.croppieImage = output;
        const signBlob = b64toBlob(this.cropped, "image/png");
        this.uploadImage(signBlob);
      });
    },

    EditFormPreFilledValue() {
      const { AdId } = this.$route.query;
      // console.log(detail);
      if (AdId) {
        ApiRequest(
          constant.ADS_BASE_API_URL,
          `/campaign/details/${AdId}`,
          "get"
        ).then((data) => {
          console.log(data);
          this.detail = data.data;
          console.log(this.detail);
          if (this.detail) {
            this.title = this.detail.name;
            this.description = this.detail.description;
            this.startDate = new Date(this.detail.startDate).toISOString();
            this.endDate = new Date(this.detail.endDate).toISOString();
            this.selectedShopId = this.detail.shopId;
            this.whatsappNumber = this.detail.campaignAction.whatsAppNumber;
            this.whatsappLink = this.detail.campaignAction.actionURL;
            this.websiteUrl = this.detail.campaignAction.actionURL;
            this.setImage(this.detail);
            this.setMediaType(this.detail);
            if (this.detail.pincodes && this.detail.pincodes.length > 0) {
              this.selectedPincodeOption = "ADD_PINCODE";
              this.supportedPincodeList = this.detail.pincodes;
            } else {
              this.selectedPincodeOption = "ALL_INDIA";
            }
            this.setProductDetails(data.data);
            // this.pincodesList = this.detail.pincodes;
          }
        });
      }
    },

    setProductDetails(detail) {
      if (detail.shopSellerItemRelationshipId) {
        this.adsType = "Products";
        document.getElementById("shops").disabled = true;
        this.selectedProductId = detail.shopSellerItemRelationshipId;
        this.getProductsOfShop(detail.shopId);
      }
      document.getElementById("products").disabled = true;
    },

    setImage(detail) {
      console.log("hi");
      if (detail.campaignMedia.length) {
        this.imagePreview = detail.campaignMedia[0].mediaURL;
        this.cropped = detail.campaignMedia[0].mediaURL;
      }
    },

    setMediaType(detail) {
      if (detail.mediaType) {
        this.mediaType = detail.mediaType;
      }
    },
  },
};
</script>
<style lang="scss">
.add-count {
  display: flex;
  align-items: center;
  font-size: 0.688em;
  color: green;
  margin-bottom: 8px;
  font-weight: 600;
}
.total-image {
  width: 20px;
  background: #777;
  border-radius: 50%;
  margin-left: 4px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
@import "@/assets/scss/product-register";
@import "@/assets/scss/create-ads";
</style>
